import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import HC_3d from 'highcharts/highcharts-3d';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
import * as moment from 'moment';
import { SearchEmployeeComponent } from 'src/app/components/search-employee/search-employee.component';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { ToolsService } from 'src/app/utils/tools.service';
HC_exporting(Highcharts);
HC_3d(Highcharts);
declare var $: any;

@Component({
  selector: 'app-summary-adviser',
  templateUrl: './summary-adviser.component.html',
  styleUrls: ['./summary-adviser.component.css']
})
export class SummaryAdviserComponent implements OnInit {
  @ViewChild(SearchEmployeeComponent) SearchEmployeeComponent: any;

  private thisComponent: SummaryAdviserComponent;
  branchofficeSlug = '';
  items: any = [];
  start_range: any = moment().startOf('month');
  end_range: any = moment().endOf('month');
  // variables
  generate: boolean = false;
  activeTab: string = 'home';
  employeeSelected: any = null;
  statusBooking: any = 0;
  sum_pax: any = 0;
  sum_total: any = 0;
  sum_paid: any = 0;
  sum_balance: any = 0;

  //para graficos
  updateFlag = false;
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  tourOptions: Highcharts.Options = {};

  obj_months = [
    { number_month: 1, name: 'Ene', value: 0 },
    { number_month: 2, name: 'Feb', value: 0 },
    { number_month: 3, name: 'Mar', value: 0 },
    { number_month: 4, name: 'Abr', value: 0 },
    { number_month: 5, name: 'May', value: 0 },
    { number_month: 6, name: 'Jun', value: 0 },
    { number_month: 7, name: 'Jul', value: 0 },
    { number_month: 8, name: 'Ago', value: 0 },
    { number_month: 9, name: 'Set', value: 0 },
    { number_month: 10, name: 'Oct', value: 0 },
    { number_month: 11, name: 'Nov', value: 0 },
    { number_month: 12, name: 'Dec', value: 0 }
  ];

  params: any = {
    employee_id: null
  };

  constructor(
    private routeActivated: ActivatedRoute,
    private router: Router,
    private bookingsService: BookingsService,
    private globalService: GlobalService,
    public toolsService: ToolsService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.thisComponent = this;
  }

  ngOnInit() {
    this.generateHistoryMonth();
    this.generateGraphHistoryTours({name:"Tour", y:0},0);
  }

  generateCalendar() {
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD'
        },
        ranges: {
          'Este Mes': [moment().startOf('month'), moment().endOf('month')],
          'Anterior Mes': [
            moment()
              .subtract(1, 'month')
              .startOf('month'),
            moment()
              .subtract(1, 'month')
              .endOf('month')
          ],
          'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
          'Últimos 15 días': [moment().subtract(14, 'days'), moment()],
          Hoy: [moment(), moment()],
          Ayer: [moment().subtract(1, 'days'), moment().subtract(1, 'days')]
        },
        startDate: component_.start_range,
        endDate: component_.end_range,
        showDropdowns: true
      },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
      }
    );
  }

  list() {
    if (this.validate()) {
      let val_params =
        'employee_id=' +
        this.params.employee_id +
        '&status_booking=' +
        this.statusBooking +
        '&start_range=' +
        this.start_range.format('YYYY-MM-DD') +
        '&end_range=' +
        this.end_range.format('YYYY-MM-DD');

      this.bookingsService.reportsummaryAdviser(val_params).subscribe({
        next: (data: any) => {
          this.sum_pax = 0;
          this.sum_total = 0;
          this.sum_paid = 0;
          this.sum_balance = 0;
          this.items = data.results;
          for (let i in this.items) {
            this.sum_pax = Number(this.items[i].nro_pax) + this.sum_pax;
            this.sum_total = Number(this.items[i].total) + this.sum_total;
            this.sum_paid = Number(this.items[i].total_paid) + this.sum_paid;
            this.sum_balance =
              Number(this.items[i].total) -
              Number(this.items[i].total_paid) +
              this.sum_balance;
          }
        }
      });
    }
  }
  

  validate() {
    if (this.params.employee_id == null) {
      this.alertifyMsg.warning('Debe seleccionar el empleado');
      this.SearchEmployeeComponent.focused();
      return false;
    }
    return true;
  }

  selectedEmployeeSearch(item_: any) {
    this.employeeSelected = item_;
    this.params.employee_id = item_.id;
    this.generate = true;
    setTimeout(() => {
      this.activeTab = 'home';
      this.generateCalendar();
    }, 250);
  }

  removeEmployee() {
    this.employeeSelected = null;
    this.params.employee_id = null;
    this.reset();
    setTimeout(() => {
      this.SearchEmployeeComponent.focused();
    }, 150);
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
    if (this.activeTab == 'historymonth') {
      let val_params = 'employee_id=' + this.params.employee_id;
      this.bookingsService.reportHistoryMonthAdviser(val_params).subscribe({
        next: (data: any) => {
          let history_data = data.results;
          let series: any = [];
          for (let i in this.obj_months) {
            for (let j in history_data) {
              if (
                this.obj_months[i].number_month == history_data[j].number_month
              ) {
                this.obj_months[i].value = parseFloat(
                  history_data[j].quantity_month
                );
              }
            }
            series.push(this.obj_months[i].value);
          }
          setTimeout(() => {
            this.updateChartData(series);
          }, 250);
        }
      });
    }

    if (this.activeTab == 'historytours') {
      this.initHistoryTours();     
    }
  }


  generateHistoryMonth() {
    this.chartOptions = {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Histórico registro de reservas confirmadas por mes'
      },
      subtitle: {
        text: 'Año: ' + moment().year()
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.y}'
          }
        }
      },
      xAxis: {
        categories: [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'May',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Oct',
          'Nov',
          'Dic'
        ]
      },
      yAxis: {
        title: {
          text: 'Cantidad'
        }
      },
      series: [
        {
          name: 'Meses',
          type: 'line',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ]
    };
  }

  updateChartData(series: any) {
    this.chartOptions = {
      series: [
        {
          name: 'N° reservas',
          type: 'column',
          data: series
        }
      ]
    };
    this.updateFlag = true;
  }

  initHistoryTours() {
    this.start_range = moment().startOf('month');
    this.end_range = moment().endOf('month');
    let component_ = this.thisComponent;
    (<any>$('#date_range_tours')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD'
        },
        startDate: component_.start_range,
        endDate: component_.end_range,
        showDropdowns: true
      },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
      }
    );
  }

  generateGraphHistoryTours(series:any, total_pax:any) {
    this.tourOptions = {
      chart: {
        renderTo: 'container',
        type: 'pie',

        marginTop: 100 // Ajusta el valor según el espacio que desees entre el gráfico y el subtítulo
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:0f} pax</b>'
      },
      title: {
        text: 'N° PAX POR TOURS (referenciado de la fecha asignada para cada tour), solo de reservas confirmadas',
        style: {
          fontSize: '15px'
        }
      },
      subtitle: {
        text: 'Total registros: '+total_pax+' PAX'
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: [
            {
              enabled: true,
              format: '{point.name}',
              style: {
                fontSize: '0.8em'
              },
              x: 0, // Mueve el label a la derecha
              y: -20 // Mueve el label hacia arriba
            },
            {
              enabled: true,
              format: '{point.y} pax',
              style: {
                fontSize: '0.8em',
                fontWeight: '500'
              }
            }
          ],
          showInLegend: true
        }
      },
      series: [
        {
          type: 'pie',
          name: 'N°:',
          data:series
          // data: [
          //   {
          //     name: 'EV',
          //     y: 23.9
          //   },
          //   {
          //     name: 'Hybrids',
          //     y: 12.6
          //   },
          //   {
          //     name: 'Diesel',
          //     y: 37.0
          //   },
          //   {
          //     name: 'Petrol',
          //     y: 26.4
          //   }
          // ]
        }
      ]
    };
  }

  loadDataHistoryTours(){
    let val_params =
    'employee_id=' +
    this.params.employee_id +
    '&start_range=' +
    this.start_range.format('YYYY-MM-DD') +
    '&end_range=' +
    this.end_range.format('YYYY-MM-DD');
    
  this.bookingsService.reportHistoryTourAdviser(val_params).subscribe({
    next: (data: any) => {
      let history_data = data.results;
      let series: any = [];
      let total_pax: any = 0;
      for (let i in history_data) {
        let obj_:any = {
          name:history_data[i].description,
          y: Number(history_data[i].total),
        };
        series.push(obj_);
        total_pax = total_pax + Number(history_data[i].total);
      }
      setTimeout(() => {
        this.generateGraphHistoryTours(series, total_pax);
      }, 250);
    }
  });
}

  refresh() {
    this.items = [];
    this.generateCalendar();
  }

  reset() {
    this.generate = false;
    this.items = [];
    this.start_range = moment().startOf('month');
    this.end_range = moment().endOf('month');
    this.generateHistoryMonth();
    this.generateGraphHistoryTours({name:"Tour", y:0},0);
    for (let i in this.obj_months) {
      this.obj_months[i].value = 0;
    }
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reportes/lista']);
  }
}
